import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'Inicio', id: 'inicio' },
    { label: 'Sobre Mí', id: 'sobre-mi' },
    { label: 'Servicios', id: 'servicios' },
    { label: 'Contacto', id: 'contacto' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/166c4650-d823-4854-836a-5c16fca6bf1f.png"
              alt="Logo"
              className="h-12 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('inicio')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-gold' : 'text-white hover:text-gold'
              }`}
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('sobre-mi')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-gold' : 'text-white hover:text-gold'
              }`}
            >
              Sobre Mí
            </button>
            <button
              onClick={() => scrollToSection('experiencia')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-gold' : 'text-white hover:text-gold'
              }`}
            >
              Experiencia
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-gray-700 hover:text-gold' : 'text-white hover:text-gold'
              }`}
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="px-6 py-2.5 bg-gold text-black text-sm font-semibold rounded-full hover:bg-gold-light transition-all whitespace-nowrap cursor-pointer"
            >
              Contacto
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden p-2 cursor-pointer ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className={`ri-menu-line text-2xl`}></i>
            </div>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden bg-white shadow-lg">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('inicio')}
              className="block w-full text-left text-gray-700 hover:text-gold font-medium cursor-pointer"
            >
              Inicio
            </button>
            <button
              onClick={() => scrollToSection('sobre-mi')}
              className="block w-full text-left text-gray-700 hover:text-gold font-medium cursor-pointer"
            >
              Sobre Mí
            </button>
            <button
              onClick={() => scrollToSection('experiencia')}
              className="block w-full text-left text-gray-700 hover:text-gold font-medium cursor-pointer"
            >
              Experiencia
            </button>
            <button
              onClick={() => scrollToSection('servicios')}
              className="block w-full text-left text-gray-700 hover:text-gold font-medium cursor-pointer"
            >
              Servicios
            </button>
            <button
              onClick={() => scrollToSection('contacto')}
              className="block w-full text-left px-6 py-2.5 bg-gold text-black font-semibold rounded-full hover:bg-gold-light transition-all cursor-pointer"
            >
              Contacto
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
